import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {MemberOfferAcceptor} from "./member_offer_acceptor"

export const memberOfferAcceptorLoader = function (options = {}) {
    componentLoader(componentConfig(MemberOfferAcceptor, MemberOfferAcceptor.config.componentTypeKey, MemberOfferAcceptor.config.baseHtmlClass), options);
};

